export default __webpack_public_path__ + "static/media/message-play.13b409c4.svg";